// extracted by mini-css-extract-plugin
export default {"nav":"OKrArEjQ6Lvlr69zG0oT","type-b":"nS8jG7T9KvkKMguqvXHB"};